module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_nose_mouth_width.54311800.jpg";